import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng';
import { Message } from 'src/app/classes/Message';
import { INonMovementDescription } from 'src/app/interfaces/non-movement-description';
import { NonMovementDescriptionService } from 'src/app/services/non-movement-description.services';

@Component({
  selector: 'app-non-movement-descriptions',
  templateUrl: './non-movement-descriptions.component.html',
  styleUrls: ['./non-movement-descriptions.component.css'],
})
export class NonMovementDescriptionsComponent implements OnInit {
  private _manageMode: number;
  @Input('manageMode')
  set manageMode(value: number) {
    this._manageMode = value;
  }
  get manageMode(): number {
    return this._manageMode;
  }

  public nonMovementDescriptions: INonMovementDescription[];
  public isDescriptionFormEnabled: boolean = false;
  public descriptionForm: UntypedFormGroup;
  public isSaving: boolean = false;

  constructor(
    private nonMovementDescriptionService: NonMovementDescriptionService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.loadDescriptions();
  }

  loadDescriptions() {
    this.nonMovementDescriptionService.getAll().then((res) => {
      this.nonMovementDescriptions = res;
    });
  }

  resetDescriptionForm() {
    this.descriptionForm = new UntypedFormGroup({
      id: new UntypedFormControl(0),
      description: new UntypedFormControl(null, Validators.compose([Validators.required])),
      xeroCode: new UntypedFormControl(null, Validators.compose([Validators.required])),
      logic: new UntypedFormControl(),
      isDebit: new UntypedFormControl(false, Validators.compose([Validators.required])),
      includeVAT: new UntypedFormControl(false, Validators.compose([Validators.required])),
    });
  }
  showDescriptionFormDialog = () => {
    this.resetDescriptionForm();
    this.isDescriptionFormEnabled = true;
  };
  saveDescription(formValue) {
    if (formValue) {
      this.isSaving = true;
      if (!formValue.id) {
        this.nonMovementDescriptionService
          .create(formValue)
          .then((res) => {
            this.loadDescriptions();
            this.isDescriptionFormEnabled = false;
            this.isSaving = false;
          })
          .catch((err) => {
            console.error('Error Creating New Description', err);
            this.messageService.add(Message.Error(err.error, 'Error'));
            this.isSaving = false;
          });
      } else {
        this.nonMovementDescriptionService
          .update(formValue.id, formValue)
          .then((res) => {
            this.loadDescriptions();
            this.isDescriptionFormEnabled = false;
            this.isSaving = false;
          })
          .catch((err) => {
            console.error('Error updating New Description', err);
            this.messageService.add(Message.Error(err.error, 'Error'));
            this.isSaving = false;
          });
      }
    }
  }
  modifyDescription(description) {
    this.showDescriptionFormDialog();
    if (description) {
      this.descriptionForm = new UntypedFormGroup({
        id: new UntypedFormControl(description.id),
        description: new UntypedFormControl(
          description.description,
          Validators.compose([Validators.required]),
        ),
        xeroCode: new UntypedFormControl(
          description.xeroCode,
          Validators.compose([Validators.required]),
        ),
        logic: new UntypedFormControl(description.logic),
        isDebit: new UntypedFormControl(
          description.isDebit,
          Validators.compose([Validators.required]),
        ),
        includeVAT: new UntypedFormControl(
          description.includeVAT,
          Validators.compose([Validators.required]),
        ),
      });
    }
  }
  deleteDescription(description) {
    // confirm you wish to delete
    if (description.id) {
      this.confirmationService.confirm({
        message: `Confirm you want to delete description '${description.description}'?`,
        accept: () => {
          this.nonMovementDescriptionService
            .delete(description.id)
            .then((res) => {
              this.loadDescriptions();
            })
            .catch((err) => {
              console.log(err);
            });
        },
        reject: () => console.log('User selected to not delete description'),
      });
    }
  }
}
